module.exports = __webpack_public_path__ + "img/application-powerpoint.7e6b5c76.png";